import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { YamsContext } from "../../context";
import { YamsCoreController } from "../../controllers/YamsCoreController";
import { useYamsListener } from "../../hooks";

/**
 * FIXME: For now, we always create new api to trigger reload via Object.create
 *   Improvement 1: memoize object by changed methods
 *   Improvement 2: Add smart subscription system, so that each item may subscribe to a given api/value
 */
export var YamsApi = function YamsApi(_ref) {
  var children = _ref.children,
    controller = _ref.controller;
  useYamsListener(controller);
  var onLoad = controller.onLoad,
    setMapInstance = controller.setMapInstance;
  var isReady = controller.isReady();
  return /*#__PURE__*/React.createElement(YamsContext.Provider, {
    value: Object.create(controller)
  }, useMemo(function () {
    return children({
      instanceRef: setMapInstance,
      isReady: isReady,
      onLoad: onLoad
    });
  }, [children, isReady, setMapInstance, onLoad]));
};
YamsApi.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  controller: PropTypes.instanceOf(YamsCoreController)
} : {};